import { useRegisterSW } from 'virtual:pwa-register/react'

export function PWAUpdatePrompt() {
  const {
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegisteredSW(swUrl) {
      console.log('[PWA] Service worker registered:', swUrl)
    },
    onRegisterError(err) {
      console.error('[PWA] Service worker registration error:', err)
    },
  })

  if (!needRefresh) return null

  return (
    <div className="pwa-update-toast" role="alert">
      <div className="pwa-update-toast-content">
        <strong>New version available</strong>
        <p>Reload to get the latest improvements.</p>
        <div className="pwa-update-toast-actions">
          <button
            className="pwa-update-btn-primary"
            onClick={() => updateServiceWorker(true)}
          >
            Reload
          </button>
          <button
            className="pwa-update-btn-ghost"
            onClick={() => setNeedRefresh(false)}
          >
            Later
          </button>
        </div>
      </div>
    </div>
  )
}
